import { gql } from '@apollo/client';

export const DELETE_ROLE = gql`
  mutation DeleteRole($input: DeleteByIdInput!) {
    deleteRole(input: $input) {
      success
      message
      messageCode
    }
  }
`;

export interface DeleteRoleInput {
  id: number;
}

export interface DeleteRoleResponse {
  deleteRole: {
    success: boolean;
    message: string;
    messageCode?: string | null;
  };
}

export interface DeleteRoleVariables {
  input: DeleteRoleInput;
}

